function buildQuery(params = {}) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value != null && value !== "") search.set(key, String(value));
  }
  const q = search.toString();
  return q ? `?${q}` : "";
}

async function requestJson(path, options = {}) {
  const res = await fetch(path, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
}

export async function fetchAdminVehicleDepreciation(params = {}) {
  return requestJson(`/api/admin/mobility/vehicle-depreciation${buildQuery(params)}`);
}

export async function recalculateListingDepreciation(listingId) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/recalculate-depreciation`,
    { method: "POST" }
  );
}

export async function recalculateAllDepreciation(params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-depreciation/recalculate${buildQuery(params)}`,
    { method: "POST" }
  );
}
